import React, { FC, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "@material-ui/core";
import TextFieldComponent from "../../components/TextFieldComponent";
import TextFieldPassword from "../../components/TextFieldPassword";
import ButtonComponent from "../../components/ButtonComponent";
import Title from "../../components/Title";
import * as Validations from "../../helpers/validations";
import { utilities } from "../../helpers/utilities";
import UserModel from "../../models/user-model";
import { AuthReducerState } from "../../flux/reducers/auth-reducer";
import { signup, clearAuthLoading } from "../../flux/actions/auth-actions";
import { modules } from "../../constants/serverErrors-constants";
import moment from "moment";
//styles
import { useStyles } from "./styles";
import DatePickerComponent from "../../components/DatePickerComponent";
import ScreenLoader from "../../components/ScreenLoader";

const SignUp: FC = () => {
  //initialize styles
  const classes = useStyles();
  //Redux
  const dispatcher = useDispatch();
  const user: UserModel = useSelector((state: any) => state.authReducer.user);
  const authReducer: AuthReducerState = useSelector(
    (state: any) => state.authReducer
  );

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [date, setDate] = useState<Date | null>(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({
    name: "",
    password: "",
    email: "",
    confirmPassword: "",
    birthdate: "",
  });

  useEffect(() => {
    dispatcher(clearAuthLoading());
  }, [dispatcher]);

  useEffect(() => {
    if (
      authReducer.errorStatus === 422 &&
      authReducer.errorMessage?.includes(modules.EMAIL_ERROR)
    ) {
      setErrors({ ...errors, email: "Este email ya está en uso." });
    }
  }, [authReducer.errorStatus]);

  useEffect(() => {
    if (user && user.id) window.location.href = "/";
  }, [user]);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const nameErrors = Validations.validate([Validations.required], name);
    const emailErrors = Validations.validate(
      [Validations.required, Validations.emailText],
      email
    );
    const passwordErrors = Validations.validate(
      [Validations.required, Validations.minLength6, Validations.maxLength25],
      password
    );

    let dateError = Validations.dateRequired(date);
    const range = moment().diff(date, "years");
    dateError =
      dateError === "" && range <= 18
        ? "No puedes ser menor de edad para registrarte"
        : dateError;
    let confirmPasswordErrors = Validations.required(confirmPassword);
    confirmPasswordErrors =
      confirmPasswordErrors === ""
        ? Validations.matchPasswords(password, confirmPassword)
        : confirmPasswordErrors;

    setErrors({
      name: nameErrors,
      email: emailErrors,
      password: passwordErrors,
      confirmPassword: confirmPasswordErrors,
      birthdate: dateError,
    });
    const correctedPassword = password.trim();
    const correctedEmail = email.trim();
    const correctedconfirmPassword = confirmPassword.trim();

    if (
      nameErrors ||
      emailErrors ||
      passwordErrors ||
      confirmPasswordErrors ||
      dateError
    )
      return;
    dispatcher(
      signup({
        user: {
          full_name: name,
          email: correctedEmail,
          password: correctedPassword,
          confirmPassword: correctedconfirmPassword,
          birth_date: date,
        },
      })
    );
  };

  return (
    <Container component="main" maxWidth="sm">
      <ScreenLoader isOpen={authReducer.loading} />
      <form className={classes.form} onSubmit={onSubmit}>
        <Title value="Regístrate" />
        <TextFieldComponent
          error={utilities.returnErrorFlag(errors.name)}
          helperText={errors.name}
          label={"Nombre"}
          type="text"
          capitalize="default"
          onChange={(e) => {
            setName(e.target.value.trim());
            setErrors({ ...errors, name: "" });
          }}
        />
        <TextFieldComponent
          error={utilities.returnErrorFlag(errors.email)}
          helperText={errors.email}
          label={"Email"}
          type="text"
          onChange={(e) => {
            setEmail(e.target.value.trim());
            setErrors({ ...errors, email: "" });
          }}
        />
        <DatePickerComponent
          error={utilities.returnErrorFlag(errors.birthdate)}
          value={date}
          label="Fecha de nacimiento"
          disableFuture
          helperText={errors.birthdate}
          onChange={(date) => {
            setDate(date);
            setErrors({ ...errors, birthdate: "" });
          }}
        />
        <TextFieldPassword
          error={utilities.returnErrorFlag(errors.password)}
          helperText={errors.password}
          label={"Contraseña"}
          onChange={(e) => {
            setPassword(e.target.value.trim());
            setErrors({ ...errors, password: "" });
          }}
        />
        <TextFieldPassword
          error={utilities.returnErrorFlag(errors.confirmPassword)}
          helperText={errors.confirmPassword}
          label={"Confirmar contraseña"}
          onChange={(e) => {
            setConfirmPassword(e.target.value.trim());
            setErrors({ ...errors, confirmPassword: "" });
          }}
        />
        <ButtonComponent value="Registrarse" type="submit" color="secondary" variant="contained"/>
      </form>
    </Container>
  );
};

export default SignUp;
